// 课程详情
const courseDetail = () => import('@/pages/courseDetail/courseDetail.vue');
const branchSchoolCourseDetail = () => import('@/pages/branchSchoolCourseDetail/courseDetail.vue');
const GroupBuyDetail = () => import('@/pages/courseDetail/courseActivity/groupBuy/GroupBuyDetail.vue');
// 精讲课程详情
const projectDetail = () => import('@/pages/video/projectDetail.vue');
export default [
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: courseDetail,
    meta: {
      title: '课程详情',
      // requireAuth: true,
    },
  },
  {
    path: '/groupProgress',
    name: 'groupProgress',
    component: GroupBuyDetail,
    meta: {
      title: '拼团详情',
      // requireAuth: true,
    },
  },
  {
    path: '/projectDetail',
    name: 'projectDetail',
    component: projectDetail,
    meta: {
      title: '精讲课程',
      // requireAuth: true,
    },
  },
  {
    path: '/branchSchoolCourseDetail',
    name: 'branchSchoolCourseDetail',
    component: branchSchoolCourseDetail,
    meta: {
      title: '课程详情',
      // requireAuth: true,
    },
  },
];
